module.exports = __webpack_public_path__ + "static/media/Validation_2_Géné X_3.0.19b362bf.pdf";